import React, { useEffect, useState } from "react";
import "./ContactModal.css";

const images = [
  "/img1.jpeg",
  "/img2.jpeg",
  "/img3.jpeg",
];

const ContactModal = ({ isOpen, onClose }) => {
  const [index, setIndex] = useState(0);
  const [fade, setFade] = useState(true);

  // Número de WhatsApp basado en tu información de contacto
  const WHATSAPP_NUMBER = "573015114267"; 

  useEffect(() => {
    if (!isOpen) return;

    const interval = setInterval(() => {
      setFade(false); // inicia salida

      setTimeout(() => {
        setIndex((prev) => (prev + 1) % images.length);
        setFade(true); // entrada suave
      }, 300);
    }, 2500);

    return () => clearInterval(interval);
  }, [isOpen]);

  const handleWhatsAppClick = () => {
    const message = encodeURIComponent("Hola FIORI, me gustaría obtener más información sobre sus productos y servicios.");
    const whatsappUrl = `https://wa.me/${WHATSAPP_NUMBER}?text=${message}`;
    
    // Redirección directa en la misma pestaña para evitar bloqueos de ventanas emergentes
    window.location.href = whatsappUrl;
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>

        <h2>Contacto</h2>

        <div className="info">
          <p><strong>📞 Teléfono:</strong> +57 301 511 4266</p>
          <p><strong>📍 Dirección:</strong> CR 49 # 134 SUR 26 (Local 106) Caldas-Antioquia, Colombia</p>
        </div>

        {/* SLIDER CON FADE */}
        <div className="slider">
          <img
            src={images[index]}
            alt="slide"
            className={fade ? "fade-in" : "fade-out"}
          />
        </div>

        {/* Botón con la lógica de redirección añadida */}
        <button className="whatsapp-btn" onClick={handleWhatsAppClick}>
          💬 Contactar por WhatsApp
        </button>

        <button className="close-btn" onClick={onClose}>✖</button>

      </div>
    </div>
  );
};

export default ContactModal;